// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.folder-browser-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.mcp-selector {
  display: flex;
  gap: 4px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
}

.mcp-tab {
  background: transparent;
  border: none;
  padding: 10px 18px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.mcp-tab:hover:not(:disabled) {
  color: #000;
}

.mcp-tab.active {
  color: var(--button-color, #1976d2);
  border-bottom-color: var(--button-color, #1976d2);
}

.mcp-tab:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.filter-modal {
  background: #fff;
  border-radius: 8px;
  width: 480px;
  max-width: 90vw;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
}

.filter-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
}

.filter-modal-header h3 {
  margin: 0;
  font-size: 18px;
}

.modal-close {
  background: transparent;
  border: none;
  font-size: 22px;
  cursor: pointer;
  color: #666;
}

.filter-modal-body {
  padding: 20px;
}

.filter-modal-body .form-group {
  margin-bottom: 12px;
}

.filter-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.filter-preview {
  margin-top: 16px;
  padding: 10px 14px;
  background: #f5f7fa;
  border-radius: 6px;
  font-size: 14px;
}

.filter-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 20px;
  border-top: 1px solid #eee;
}

.folder-browser-page .page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.folder-browser-page .page-header h1 {
  margin: 0;
  font-size: 1.8rem;
  color: #333;
}

.folder-browser-page .header-actions {
  display: flex;
  gap: 1rem;
}

.folder-browser-page .error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

/* Batch Progress */
.batch-progress {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.batch-progress-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
}

.batch-progress-header h3 {
  margin: 0;
  font-size: 1rem;
  color: #333;
}

.batch-status {
  font-size: 0.85rem;
  color: #666;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.batch-progress--materializing {
  border-left: 3px solid var(--button-color, #007bff);
}

.batch-progress--materializing .spinner {
  width: 14px;
  height: 14px;
  border: 2px solid #d0d0d0;
  border-top-color: var(--button-color, #007bff);
  border-radius: 50%;
  animation: batch-spinner-rotate 0.9s linear infinite;
  display: inline-block;
}

@keyframes batch-spinner-rotate {
  to { transform: rotate(360deg); }
}

.progress-bar-container {
  height: 8px;
  background: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 0.5rem;
}

.progress-bar-fill {
  height: 100%;
  background: var(--button-color, #007bff);
  transition: width 0.3s ease;
}

.progress-text {
  margin: 0;
  font-size: 0.85rem;
  color: #666;
}

.current-file {
  margin: 0.5rem 0 0 0;
  font-size: 0.85rem;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.failed-count {
  color: #dc3545;
}

.batch-completed {
  background: #d4edda;
  color: #155724;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.batch-completed p {
  margin: 0;
}

/* Breadcrumb */
.breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 1rem;
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  border-radius: 6px;
}

.breadcrumb-item {
  background: none;
  border: none;
  color: var(--button-color, #007bff);
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  border-radius: 3px;
  font-size: 0.9rem;
}

.breadcrumb-item:hover {
  background: #e9ecef;
}

.breadcrumb-separator {
  color: #999;
  font-size: 0.9rem;
}

/* Folder Actions */
.folder-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

/* File List */
.file-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.file-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.875rem 1rem;
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.15s ease;
}

.file-item:hover {
  background: #f8f9fa;
  border-color: #dee2e6;
}

.file-item.selected {
  border-color: var(--button-color, #007bff);
  background: #f0f7ff;
}

.file-item.highlight-flash {
  animation: highlightFlash 2s ease-out;
}

@keyframes highlightFlash {
  0%, 30% { background: #fff3cd; border-color: #ffc107; }
  100% { background: white; border-color: #eee; }
}

.file-item.directory {
  font-weight: 500;
}

.file-item.directory:hover {
  background: #e3f2fd;
}

.folder-checkbox {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  cursor: pointer;
  accent-color: var(--button-color, #007bff);
}

.folder-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.file-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.file-name {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.file-status {
  flex-shrink: 0;
}

/* Status Badges */
.status-badge {
  padding: 0.25rem 0.625rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
}

.status-new {
  background: #e3f2fd;
  color: #1565c0;
}

.status-pending {
  background: #fff3e0;
  color: #e65100;
}

.status-queued {
  background: #e8eaf6;
  color: #3949ab;
}

.status-processing {
  background: #fff8e1;
  color: #f9a825;
}

.status-completed {
  background: #e8f5e9;
  color: #2e7d32;
}

.status-failed {
  background: #ffebee;
  color: #c62828;
}

.status-skipped {
  background: #fff3e0;
  color: #e65100;
}

.status-invoice {
  background: #e8f5e9;
  color: #2e7d32;
}

/* View Analysis Button */
.view-analysis-btn {
  background: transparent;
  border: 1px solid var(--button-color, #007bff);
  color: var(--button-color, #007bff);
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.view-analysis-btn:hover {
  background: var(--button-color, #007bff);
  color: white;
}

/* Download Button */
.download-btn {
  background: #28a745;
  border: none;
  color: white;
  padding: 0.25rem 0.75rem;
  border-radius: 4px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.download-btn:hover {
  background: #218838;
}

.delete-btn {
  background: transparent;
  border: none;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
  cursor: pointer;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

.delete-btn:hover {
  opacity: 1;
}

/* Loading and Empty States */
.loading {
  text-align: center;
  padding: 3rem;
  color: #666;
  font-size: 1rem;
}

.empty-folder {
  text-align: center;
  padding: 3rem;
  color: #999;
  font-style: italic;
}

/* Buttons */
.folder-browser-page .btn-primary {
  padding: 0.625rem 1.25rem;
  background: var(--button-color, #007bff);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  transition: background 0.2s;
}

.folder-browser-page .btn-primary:hover {
  background: var(--hover-color, #0056b3);
}

.folder-browser-page .btn-primary:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.folder-browser-page .btn-secondary {
  padding: 0.5rem 1rem;
  background: white;
  color: #555;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s;
}

.folder-browser-page .btn-secondary:hover {
  background: #f5f5f5;
  border-color: #bbb;
}

.folder-browser-page .btn-secondary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.folder-browser-page .btn-small {
  padding: 0.375rem 0.75rem;
  font-size: 0.8rem;
}

/* Folder Badge */
.folder-badge {
  margin-left: 0.5rem;
  padding: 0.15rem 0.5rem;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 500;
  text-transform: uppercase;
}

.folder-badge-results {
  background: #e8f5e9;
  color: #2e7d32;
}

/* Responsive */
@media (max-width: 768px) {
  .folder-browser-page {
    padding: 1rem;
  }

  .folder-browser-page .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .file-item {
    flex-wrap: wrap;
  }

  .file-name {
    width: 100%;
    order: -1;
    margin-bottom: 0.5rem;
  }
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
  padding: 0.8rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.pagination-info {
  color: #666;
  font-size: 0.85rem;
  margin-left: 0.6rem;
}

.pagination-nav {
  padding: 0.4rem 0.8rem;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.pagination-nav:hover:not(:disabled) {
  background: #f0f0f0;
}

.pagination-nav:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-page {
  min-width: 2.2rem;
  padding: 0.4rem 0.6rem;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
}

.pagination-page:hover:not(:disabled):not(.active) {
  background: #f0f0f0;
}

.pagination-page.active {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
  cursor: default;
}

.pagination-page:disabled:not(.active) {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-ellipsis {
  color: #999;
  padding: 0 0.2rem;
}

.folder-search {
  position: relative;
  margin-bottom: 1rem;
}

.folder-search-input {
  width: 100%;
  padding: 0.6rem 2rem 0.6rem 0.8rem;
  font-size: 0.95rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.folder-search-input:focus {
  outline: none;
  border-color: #007bff;
}

.folder-search-clear {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.4rem;
  color: #999;
  cursor: pointer;
  padding: 0 0.4rem;
}

.folder-search-clear:hover {
  color: #555;
}

.folder-search-results {
  margin-bottom: 1.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  max-height: 400px;
  overflow-y: auto;
}

.folder-search-results .search-summary {
  padding: 0.5rem 0.8rem;
  background: #f5f5f5;
  font-size: 0.85rem;
  color: #666;
  border-bottom: 1px solid #e0e0e0;
}

.folder-search-results .search-results-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.folder-search-results .search-result-item {
  display: flex;
  flex-direction: column;
  padding: 0.6rem 0.8rem;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}

.folder-search-results .search-result-item:hover {
  background: #f8f9fa;
}

.folder-search-results .search-result-item:last-child {
  border-bottom: none;
}

.folder-search-results .search-result-name {
  font-weight: 500;
  color: #333;
}

.folder-search-results .search-result-path {
  font-size: 0.8rem;
  color: #888;
  margin-top: 0.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FolderBrowserPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;EAC9C,kBAAkB;EAClB,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mCAAmC;EACnC,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,UAAU,mBAAmB,EAAE,qBAAqB,EAAE;EACtD,OAAO,iBAAiB,EAAE,kBAAkB,EAAE;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,8CAA8C;EAC9C,mCAAmC;EACnC,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,yBAAyB;EACzB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,SAAS;IACT,qBAAqB;EACvB;AACF;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".folder-browser-page {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.mcp-selector {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.mcp-tab {\n  background: transparent;\n  border: none;\n  padding: 10px 18px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #666;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.2s ease;\n}\n\n.mcp-tab:hover:not(:disabled) {\n  color: #000;\n}\n\n.mcp-tab.active {\n  color: var(--button-color, #1976d2);\n  border-bottom-color: var(--button-color, #1976d2);\n}\n\n.mcp-tab:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.filter-modal {\n  background: #fff;\n  border-radius: 8px;\n  width: 480px;\n  max-width: 90vw;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n  display: flex;\n  flex-direction: column;\n}\n\n.filter-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 16px 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.filter-modal-header h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.modal-close {\n  background: transparent;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n  color: #666;\n}\n\n.filter-modal-body {\n  padding: 20px;\n}\n\n.filter-modal-body .form-group {\n  margin-bottom: 12px;\n}\n\n.filter-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.filter-preview {\n  margin-top: 16px;\n  padding: 10px 14px;\n  background: #f5f7fa;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.filter-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  padding: 14px 20px;\n  border-top: 1px solid #eee;\n}\n\n.folder-browser-page .page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n}\n\n.folder-browser-page .page-header h1 {\n  margin: 0;\n  font-size: 1.8rem;\n  color: #333;\n}\n\n.folder-browser-page .header-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.folder-browser-page .error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n/* Batch Progress */\n.batch-progress {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.batch-progress-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0.75rem;\n}\n\n.batch-progress-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  color: #333;\n}\n\n.batch-status {\n  font-size: 0.85rem;\n  color: #666;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.batch-progress--materializing {\n  border-left: 3px solid var(--button-color, #007bff);\n}\n\n.batch-progress--materializing .spinner {\n  width: 14px;\n  height: 14px;\n  border: 2px solid #d0d0d0;\n  border-top-color: var(--button-color, #007bff);\n  border-radius: 50%;\n  animation: batch-spinner-rotate 0.9s linear infinite;\n  display: inline-block;\n}\n\n@keyframes batch-spinner-rotate {\n  to { transform: rotate(360deg); }\n}\n\n.progress-bar-container {\n  height: 8px;\n  background: #e9ecef;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 0.5rem;\n}\n\n.progress-bar-fill {\n  height: 100%;\n  background: var(--button-color, #007bff);\n  transition: width 0.3s ease;\n}\n\n.progress-text {\n  margin: 0;\n  font-size: 0.85rem;\n  color: #666;\n}\n\n.current-file {\n  margin: 0.5rem 0 0 0;\n  font-size: 0.85rem;\n  color: #555;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.failed-count {\n  color: #dc3545;\n}\n\n.batch-completed {\n  background: #d4edda;\n  color: #155724;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.batch-completed p {\n  margin: 0;\n}\n\n/* Breadcrumb */\n.breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  margin-bottom: 1rem;\n  padding: 0.75rem 1rem;\n  background: #f8f9fa;\n  border-radius: 6px;\n}\n\n.breadcrumb-item {\n  background: none;\n  border: none;\n  color: var(--button-color, #007bff);\n  cursor: pointer;\n  padding: 0.25rem 0.5rem;\n  border-radius: 3px;\n  font-size: 0.9rem;\n}\n\n.breadcrumb-item:hover {\n  background: #e9ecef;\n}\n\n.breadcrumb-separator {\n  color: #999;\n  font-size: 0.9rem;\n}\n\n/* Folder Actions */\n.folder-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n/* File List */\n.file-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.file-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.875rem 1rem;\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.file-item:hover {\n  background: #f8f9fa;\n  border-color: #dee2e6;\n}\n\n.file-item.selected {\n  border-color: var(--button-color, #007bff);\n  background: #f0f7ff;\n}\n\n.file-item.highlight-flash {\n  animation: highlightFlash 2s ease-out;\n}\n\n@keyframes highlightFlash {\n  0%, 30% { background: #fff3cd; border-color: #ffc107; }\n  100% { background: white; border-color: #eee; }\n}\n\n.file-item.directory {\n  font-weight: 500;\n}\n\n.file-item.directory:hover {\n  background: #e3f2fd;\n}\n\n.folder-checkbox {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  cursor: pointer;\n  accent-color: var(--button-color, #007bff);\n}\n\n.folder-checkbox:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.file-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n.file-name {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.file-status {\n  flex-shrink: 0;\n}\n\n/* Status Badges */\n.status-badge {\n  padding: 0.25rem 0.625rem;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.status-new {\n  background: #e3f2fd;\n  color: #1565c0;\n}\n\n.status-pending {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.status-queued {\n  background: #e8eaf6;\n  color: #3949ab;\n}\n\n.status-processing {\n  background: #fff8e1;\n  color: #f9a825;\n}\n\n.status-completed {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.status-failed {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.status-skipped {\n  background: #fff3e0;\n  color: #e65100;\n}\n\n.status-invoice {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n/* View Analysis Button */\n.view-analysis-btn {\n  background: transparent;\n  border: 1px solid var(--button-color, #007bff);\n  color: var(--button-color, #007bff);\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.view-analysis-btn:hover {\n  background: var(--button-color, #007bff);\n  color: white;\n}\n\n/* Download Button */\n.download-btn {\n  background: #28a745;\n  border: none;\n  color: white;\n  padding: 0.25rem 0.75rem;\n  border-radius: 4px;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  flex-shrink: 0;\n}\n\n.download-btn:hover {\n  background: #218838;\n}\n\n.delete-btn {\n  background: transparent;\n  border: none;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.9rem;\n  cursor: pointer;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n\n.delete-btn:hover {\n  opacity: 1;\n}\n\n/* Loading and Empty States */\n.loading {\n  text-align: center;\n  padding: 3rem;\n  color: #666;\n  font-size: 1rem;\n}\n\n.empty-folder {\n  text-align: center;\n  padding: 3rem;\n  color: #999;\n  font-style: italic;\n}\n\n/* Buttons */\n.folder-browser-page .btn-primary {\n  padding: 0.625rem 1.25rem;\n  background: var(--button-color, #007bff);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 0.9rem;\n  transition: background 0.2s;\n}\n\n.folder-browser-page .btn-primary:hover {\n  background: var(--hover-color, #0056b3);\n}\n\n.folder-browser-page .btn-primary:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.folder-browser-page .btn-secondary {\n  padding: 0.5rem 1rem;\n  background: white;\n  color: #555;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.2s;\n}\n\n.folder-browser-page .btn-secondary:hover {\n  background: #f5f5f5;\n  border-color: #bbb;\n}\n\n.folder-browser-page .btn-secondary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.folder-browser-page .btn-small {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.8rem;\n}\n\n/* Folder Badge */\n.folder-badge {\n  margin-left: 0.5rem;\n  padding: 0.15rem 0.5rem;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.folder-badge-results {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .folder-browser-page {\n    padding: 1rem;\n  }\n\n  .folder-browser-page .page-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .file-item {\n    flex-wrap: wrap;\n  }\n\n  .file-name {\n    width: 100%;\n    order: -1;\n    margin-bottom: 0.5rem;\n  }\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n  margin-top: 1.5rem;\n  margin-bottom: 1rem;\n  padding: 0.8rem;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.pagination-info {\n  color: #666;\n  font-size: 0.85rem;\n  margin-left: 0.6rem;\n}\n\n.pagination-nav {\n  padding: 0.4rem 0.8rem;\n  border: 1px solid #ccc;\n  background: #fff;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.pagination-nav:hover:not(:disabled) {\n  background: #f0f0f0;\n}\n\n.pagination-nav:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-page {\n  min-width: 2.2rem;\n  padding: 0.4rem 0.6rem;\n  border: 1px solid #ccc;\n  background: #fff;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.9rem;\n}\n\n.pagination-page:hover:not(:disabled):not(.active) {\n  background: #f0f0f0;\n}\n\n.pagination-page.active {\n  background: #007bff;\n  color: #fff;\n  border-color: #007bff;\n  cursor: default;\n}\n\n.pagination-page:disabled:not(.active) {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.pagination-ellipsis {\n  color: #999;\n  padding: 0 0.2rem;\n}\n\n.folder-search {\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.folder-search-input {\n  width: 100%;\n  padding: 0.6rem 2rem 0.6rem 0.8rem;\n  font-size: 0.95rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.folder-search-input:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.folder-search-clear {\n  position: absolute;\n  right: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  font-size: 1.4rem;\n  color: #999;\n  cursor: pointer;\n  padding: 0 0.4rem;\n}\n\n.folder-search-clear:hover {\n  color: #555;\n}\n\n.folder-search-results {\n  margin-bottom: 1.5rem;\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n  background: #fff;\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.folder-search-results .search-summary {\n  padding: 0.5rem 0.8rem;\n  background: #f5f5f5;\n  font-size: 0.85rem;\n  color: #666;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.folder-search-results .search-results-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.folder-search-results .search-result-item {\n  display: flex;\n  flex-direction: column;\n  padding: 0.6rem 0.8rem;\n  border-bottom: 1px solid #f0f0f0;\n  cursor: pointer;\n}\n\n.folder-search-results .search-result-item:hover {\n  background: #f8f9fa;\n}\n\n.folder-search-results .search-result-item:last-child {\n  border-bottom: none;\n}\n\n.folder-search-results .search-result-name {\n  font-weight: 500;\n  color: #333;\n}\n\n.folder-search-results .search-result-path {\n  font-size: 0.8rem;\n  color: #888;\n  margin-top: 0.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
